var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgArrowUpSquare(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M20.667 24A3.335 3.335 0 0024 20.667v-9.334A3.335 3.335 0 0020.667 8h-9.334A3.335 3.335 0 008 11.333v9.334A3.335 3.335 0 0011.333 24zm0-2h-9.334l-.128-.006A1.335 1.335 0 0110 20.667v-9.334l.006-.128A1.335 1.335 0 0111.333 10h9.334l.128.006A1.335 1.335 0 0122 11.333v9.334l-.006.128A1.335 1.335 0 0120.667 22zm-4-2.39v-4.391l1.528 1.528.943-.942L16 12.667l-3.138 3.137.943.943 1.528-1.528v4.39h1.334z"
  }));
}

export default SvgArrowUpSquare;